/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ActorUpdateRequest = zod
	.object({
		email: zod.email().optional().describe('Actor email'),
		name: zod.string().optional().describe('Actor name')
	})
	.describe('Request body for updating an actor');

export type ActorUpdateRequest = zod.input<typeof ActorUpdateRequest>;
export type ActorUpdateRequestOutput = zod.output<typeof ActorUpdateRequest>;
